<template>
  <section class="app__section__ernest">
    <v-progress-circular
      indeterminate
      color="valid"
      v-if="pageLoaded"
    />

    <section id="app__content" v-else>
      <v-progress-linear v-model="progressValue" color="valid"/>
      <aside>{{ $t('appUser.questionnaire.completion', {progressValue}) }}</aside>
      <questionnaire-item v-for="item in items" :key="item.id" :item="item"/>

      <footer class="questionnaire__navigation__buttons">
        <v-btn color="other1"
               v-if="previousPage.id !== undefined"
               id="nav__button__previous"
               @click="navPreviousPage"
        >
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('appUser.questionnaire.button.previousPage') }}
        </v-btn>
        <v-btn color="other1"
               v-if="nextPage.id !== undefined"
               id="nav__button__next"
               @click="navNextPage"
        >
          {{ $t('appUser.questionnaire.button.nextPage') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <!--Fênetre pour valider la fin du questionnaire et le bouton pour l'ouvrir-->
        <v-btn color="valid"
               v-if="nextPage.id === undefined"
               id="nav__button__terminate"
               @click="onFinishQuestionnaire"
        >
          {{ $t('appUser.questionnaire.button.finish') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </footer>

      <v-dialog
        v-model="terminateQuestionnaire.displayDialog"
        width="500"
      >
        <header class="app__header__ernest">
          <div>
            <u-icon>Ù</u-icon>
          </div>
          <div>
            <div><span>{{ $t('app.ernestHeader.questionnaireDetail') }}</span></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div></div>
        </header>
        <section class="app__section__ernest windows__alert">
          {{ terminateQuestionnaire.message }}
        </section>
        <footer class="app__footer__ernest">
          <v-btn color="valid" @click="terminateLocal">
            {{ $t('appUser.questionnaire.button.confirm') }}
          </v-btn>
          <v-btn color="cancel" @click="terminateQuestionnaire.displayDialog = false">
            {{ $t('appUser.questionnaire.button.cancel') }}
          </v-btn>
        </footer>
      </v-dialog>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionnaireItem from '@/components/appUser/questionnaires/QuestionnaireItem'

export default {
  name: 'QuestionnairePass',
  components: { QuestionnaireItem },
  data () {
    return {
      loaded: false,
      pageItems: [],
      terminateQuestionnaire: {
        displayDialog: false,
        message: this.$t('appUser.questionnaire.terminate.message.name')
      }
    }
  },
  computed: {
    ...mapGetters('User', [
      'user'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'currentPage',
      'nextPage',
      'positionPage',
      'previousPage',
      'progressValue',
      'questionnaire'
    ]),
    items () {
      return this.currentPage.pageItems ? this.currentPage.pageItems : []
    },
    pageLoaded () {
      return !this.loaded
    }
  },
  async created () {
    if (Object.entries(this.user).length === 0) {
      // Charge l'utilisateur
      await this.loadUser()
    }
    // Charge le questionnaire
    await this.loadQuestionnaire(this.$route.params.id)

    // Récupère l'index de la page en cours
    let pageIndex = this.questionnaire.pages.findIndex(page => {
      return page.number === this.positionPage
    })

    // Charge en synchro la page en cours et en désynchro la page précédente et suivante
    await this.loadPage({
      id: this.questionnaire.pages[pageIndex].id,
      previous: pageIndex <= 0 ? null : this.questionnaire.pages[pageIndex - 1].id,
      next: pageIndex === (this.questionnaire.pages.length - 1)
        ? null
        : this.questionnaire.pages[pageIndex + 1].id
    })

    // Charge dans les data les page items
    this.pageItems = JSON.parse(JSON.stringify(this.currentPage.pageItems))

    this.loaded = true
  },
  methods: {
    ...mapActions('User', [
      'loadUser'
    ]),
    ...mapActions('UserQuestionnaire', [
      'deleteIteration',
      'loadPage',
      'loadQuestionnaire',
      'navPreviousPage',
      'navNextPage',
      'terminate'
    ]),
    async onFinishQuestionnaire () {
      (this.questionnaire.isPublished || this.questionnaire.user === this.user.id)
        ? this.terminateQuestionnaire.displayDialog = true
        : await this.deleteIteration({
          questionnaire: { id: this.questionnaire.id },
          isTest: true
        })
    },
    terminateLocal () {
      this.terminate()
      this.terminateQuestionnaire.displayDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/styleAppErnest";

  .app__section__ernest {
    position: relative;

    aside {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      top: 10px;
      right: 25px;
    }
  }

  .v-progress-linear {
    position: absolute;
    top: 0;
    left: 0;
  }

  .questionnaire__navigation__buttons {
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    #nav__button__previous {
      grid-column: 1/2;
    }

    #nav__button__next, #nav__button__terminate {
      grid-column: 4/5;
    }
  }
</style>
